<template>
 <div class="app-inner" id="previewSe">
   <div class="public-btn-small flex align-cen posta">
            <div class="public-btn-small-plan"  style="margin-left:0" @click="reback">
            返回
            </div>
            </div>
     <div class="public-tit flex align-cen">
        <div class="public-tit-list">
            <i class="icon-al-database-fill"></i>  课程预览
        </div>
    </div>
            <div class="right">
            <div class="right-tit flex align-cen">
                {{info.headline}}
            </div>
             <FilePreview :item="info" />
              <!-- 附加材料 - 最简版 -->
                <!-- 附加材料下载 -->
                 <MaterialsDownload :materials="info.materials" />
        </div>
 </div>
</template>
<script>
import {courseChapterDetail} from "@/api/index/index"  //章节列表、新增章节、章节详情
import FilePreview from '@/components/FilePreview.vue'
import MaterialsDownload from '@/components/MaterialsDownload.vue'
export default {
    components: {
    FilePreview,
    MaterialsDownload
  },
    data () {
        return {
            info:{},
        }
    },
    created() {
        this.getDetail()
    },
    methods: {
                // 获取详情
        getDetail(){
              courseChapterDetail({
                id:this.$route.query.headId
              },'get')
            .then(res => {
              this.info = res.data
            })
            .catch(err => {
            })
        },
         // 返回
        reback(){
         this.$router.push({
            name: "twoCourse",
            query:{
                twoId:this.$route.query.id,
            }
           })
        },
    },
}
</script>
<style lang="scss" scoped>
#previewSe{
    margin-bottom: 60px;
}
    .right{
        width:100%;
        height: inherit;
        position: relative;
        .right-tit{
            font-size: 32px;
            font-family: PingFang SC;
            font-weight: 400;
            color: #555555;
            line-height: 48px;
            padding: 20px 40px;
            i{
                display: none;
            }
        }
        .nr{
            width: 90%;
            margin: 0 auto;
            margin-bottom: 50px;
            border-bottom: 1px solid #ccc;
            height: calc(100% - 180px);
            overflow: auto;
        }
        .right-bot{
            position: absolute;
            width: 90%;
            left: 5%;
            bottom: 30px;
            cursor: pointer;
            color: #BDBDBD;
            line-height: 36px;
            font-size: 14px;
            i{
                font-size: 12px;
            }
        }
        .emtey{
            justify-content: center;
            text-align: center;
            padding-top: 20vh;
             color: #ccc;
            i{
                font-size: 50px;
                color: #ccc;
                
            }
            .btn{
               padding: 10px 20px;
               background: #155bd4;
               color: #fff;
               border-radius: 5px;
               margin-top: 20px;
               cursor: pointer;
            }
        }
    }
    ::v-deep {
.ql-video{
    max-width: 100%;
}
     .mobil-dia-btn{
        display: none;
    }
    .el-collapse-item__wrap,.el-collapse-item__header{
                background: transparent;
                border: none;
            }
    .el-collapse-item__content{
        padding-bottom: 0;
    }
    @media (max-width: 640px){
    .el-dialog{
        margin-top: 10vh !important;
    }
       .mobil-dia-btn{
        display: block;
    }
}
    .dia-can{
        .canvas{
            position:relative !important;
            top: 0 !important;
            display: block;
            margin: 0 auto;
        }
    }
        .dia-btn{
            width: 100px;
        	height: 32px;
				line-height: 30px;
				font-size: 14px;
				padding: 0 16px;
				border-radius: 2px;
				font-family: inherit;
				border-width: 1px;
				border-style: solid;
				text-align: center;
				vertical-align: middle;
				box-sizing: border-box;
				cursor: pointer;
				transition: all .3s;
				background: $base-color-btn;
				color: #fff;
                margin: 20px auto;
                margin-bottom: 0;
    }
    .el-dialog__body{
        padding: 20px 10px;
    }
}
</style>